module.exports = "/_next/static/images/233b10fb7e24fc6841f72cc560b4243f-apply-xs.jpg";